<crnt-visually-hidden>{{ a11yText() }}</crnt-visually-hidden>
<div class="position-relative" aria-hidden="true">
  <div>
    @for (star of emptyStars(); track $index) {
      <fa-icon class="empty-star" [icon]="star" size="xl" [fixedWidth]="true" />
    }
  </div>
  <div class="position-absolute star-container">
    @for (star of fullStars(); track $index) {
      <fa-icon
        class="filled-star"
        [icon]="star"
        size="xl"
        [fixedWidth]="true"
      />
    }
    @if (showHalfStar()) {
      <fa-icon
        class="filled-star"
        [icon]="['fas', 'star-half']"
        size="xl"
        [fixedWidth]="true"
      />
    }
  </div>
</div>
